import catalog from './pricingCatalog.json'
import type { AiTierId } from '../../types/ai'

export type PurchaseTabKey = 'TEAM' | 'PERSONAL' | 'CREDITS' | 'STORAGE'
export type BillingCycle = 'monthly' | 'yearly'
export type PlanAccent = 'slate' | 'indigo' | 'cyan' | 'violet' | 'emerald' | 'gold'
export type LimitValue = number | 'UNLIMITED' | 'UNCAPPED'

export type FeatureDefinition = {
  key: string
  category: string
  label: string
}

export type PlanSliderOption = {
  key: string
  label: string
  description: string
  monthlyPriceDelta?: number
  yearlyPriceDelta?: number
  monthlyPriceOverride?: number
  yearlyPriceOverride?: number
  memberLimit?: LimitValue
  dailyMessageLimit?: LimitValue
}

export type PricingPlan = {
  id: string
  name: string
  utilityLabel: string
  description?: string
  linkedTierId?: string
  monthlyPrice: number | null
  yearlyPrice: number | null
  oneTimePrice?: number
  monthlyCredits: number
  yearlyCredits?: number
  creditCadence: 'monthly' | 'one-time'
  memberLimit?: LimitValue
  helperLimit?: LimitValue
  dailyMessageLimit?: LimitValue
  storageGB?: LimitValue
  includedMembers?: number
  includedHelpers?: number
  memberSeatRate?: number
  helperSeatRate?: number
  accent: PlanAccent
  equipped?: boolean
  recommended?: boolean
  badge?: string
  ctaLabel: string
  sliderMode?: 'two' | 'three'
  sliderOptions?: PlanSliderOption[]
  featureKeys: string[]
  limitRows?: string[]
  /** docs/pricing/line-tier-plan.md §4 access map. Absent → legacy plan (all tiers behave as pre-rollout Line). */
  aiTierAccess?: AiTierId[]
  /** Default tier the switcher shows on first render for this plan. */
  aiDefaultTier?: AiTierId
}

export type PricingSection = {
  id: string
  eyebrow: string
  title: string
  description: string
  planIds: string[]
}

export type CreditPack = {
  id: string
  name: string
  tagline: string
  price: number
  credits: number
  accent: PlanAccent
  highlight?: string
  benefits: string[]
  featureKeys?: string[]
}

export type StorageAddOn = {
  id: string
  name: string
  description: string
  storageGB: number
  monthlyPrice: number
  yearlyPrice: number
  accent: PlanAccent
  benefits: string[]
}

export type PricingCatalog = {
  tabs: { key: PurchaseTabKey; label: string; glyph: string }[]
  teamFeatureRegistry: FeatureDefinition[]
  personalFeatureRegistry: FeatureDefinition[]
  teamSections: PricingSection[]
  teamPlans: PricingPlan[]
  personalPlans: PricingPlan[]
  creditPacks: CreditPack[]
  storageAddOns: StorageAddOn[]
  storagePlan?: {
    id: 'team_workspace_storage_pro'
    name: string
    description: string
    yearlyPriceInr: number
  }
}

export const PRICING_CATALOG = catalog as PricingCatalog
